import cx from "classnames"
import Block from "@/components/wrappers/block"
import styles from "./quote.module.css"

function Quote({ block, settings }) {
  const { attrs } = block

  if (!attrs.quote) {
    return null
  }

  const classes = [styles.quote, attrs.classList]
  let width = settings?.width ?? "column"

  const Element = ({ block }) => {
    return (
      <div className={cx(classes, styles.innerWrapper)}>
        <blockquote dangerouslySetInnerHTML={{ __html: block.quote }} />
        {block.cite && (
          <cite dangerouslySetInnerHTML={{ __html: block.cite }}></cite>
        )}
      </div>
    )
  }

  return (
    <Block block={block} width={width} gap="content">
      <Element block={block.attrs} />
    </Block>
  )
}

export default Quote
